module.exports = __webpack_public_path__ + "img/return-box_1.145fce7e.png";